/* Wholesale price display - line sheet cards and the product page.

   THE PROBLEM THIS SOLVES
   Liquid renders on the server and only knows who is LOGGED IN. But the wholesale showroom is
   used two ways: a buyer signed in as themselves, and a Coclico staff member noting on behalf of
   a client through the header picker. Those need to show the same prices. A staff member looking
   at Gravitypope's line sheet must see what Gravitypope sees, or the conversation in the showroom
   is about numbers the customer will never be invoiced.

   Currency is therefore a property of the CLIENT, resolved server-side in getContext from the fob
   checkbox on their Clients row, and it arrives here through WSApi. Liquid cannot know it, so
   Liquid renders BOTH prices into data attributes and this script reveals the right one.

   WHY BOTH PRICES ARE IN THE MARKUP
   Fetching them later would mean a second round trip per card on a 53-style line sheet. They are
   small, they are not secret (only wholesale accounts reach these pages at all), and having them
   present means the swap is instant once context resolves.

   WHY NOTHING SHOWS UNTIL CONTEXT ARRIVES
   The alternative is painting dollars and flipping to euros a moment later, which looks like a
   price change rather than a page loading. Context is cached per client in sessionStorage, so
   after the first page this is imperceptible.

   The euro FOB price is a different price Sandra sets per style, not a conversion of the dollar
   one, so nothing here multiplies by a rate. Suggested retail is always US dollars and always
   says so: retailers set their own retail but want to see ours.
*/
(function () {
  var nodes = document.querySelectorAll('[data-ws-price]');
  if (!nodes.length) return;

  var api = window.WSApi;

  function fmt(cents, cur) {
    var n = (Number(cents) || 0) / 100;
    var s = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    // Whole amounts read better without the trailing zeros on a line sheet.
    if (s.slice(-3) === '.00') s = s.slice(0, -3);
    return (String(cur).toUpperCase() === 'EUR' ? '\u20AC' : '$') + s;
  }

  function paint(currency) {
    var eur = String(currency || '').toUpperCase() === 'EUR';

    nodes.forEach(function (el) {
      var usd = el.getAttribute('data-usd');
      var fob = el.getAttribute('data-eur');
      var srp = el.getAttribute('data-srp');
      var layout = el.getAttribute('data-ws-price');   // 'card' or 'product'

      var main = eur ? fob : usd;
      var label = eur ? 'FOB' : 'WS';
      var heading = eur ? 'Wholesale FOB' : 'Wholesale (US$)';

      var html;
      if (layout === 'product') {
        html = '<div class="v-stack gap-0.5 justify-items-start">'
             + '<span class="smallcaps text-xs text-subdued">' + heading + '</span>'
             + '<span class="h4">'
             + (main ? fmt(main, eur ? 'EUR' : 'USD')
                     : '<span class="text-subdued" style="font-size:.72em;">Price on request</span>')
             + '</span></div>';
        if (srp) {
          html += '<div class="v-stack gap-0.5 justify-items-start">'
                + '<span class="smallcaps text-xs text-subdued">Suggested Retail (US$)</span>'
                + '<span class="h4 text-subdued">' + fmt(srp, 'USD') + '</span></div>';
        }
      } else {
        html = main
          ? '<span style="font-weight:400;">' + fmt(main, eur ? 'EUR' : 'USD')
            + ' <span class="smallcaps text-xs text-subdued">' + label + '</span></span>'
          : '<span class="smallcaps text-xs text-subdued">Price on request</span>';
        if (srp) {
          html += ' <span class="smallcaps text-xs text-subdued">' + fmt(srp, 'USD') + ' SRP (US$)</span>';
        }
      }

      el.innerHTML = html;
      el.removeAttribute('hidden');
    });
  }

  // No backend to ask (a preview with the app unreachable, say). Show the US
  // prices rather than an empty space: wrong for an FOB account, but a blank
  // line sheet is worse, and the notes page and every document still price
  // correctly from the backend.
  if (!api || !api.context) { paint('USD'); return; }

  var cached = api.cached ? api.cached() : null;
  if (cached && cached.currency) paint(cached.currency);

  api.context().then(function (ctx) {
    paint(ctx && ctx.currency ? ctx.currency : 'USD');
  }).catch(function () { paint('USD'); });
})();
